export default __webpack_public_path__ + "static/media/Notification_N.867198c0.svg";